export const WEAPON = {
  id: 'rpg',
  label: 'RPG-7V',
  class: 'launcher',
  slot: 'utility',
  caliber: 'PG-7VL',
  /** Gold-coin price in the armory. */
  price: 3200,

  /* A single-shot, shoulder-fired launcher. `rpm` is the practical cycle
   * cadence after firing and beginning a fresh-round reload. */
  rpm: 12,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 12,
  burstDelay: 0.1,

  magSize: 1,
  reserve: 5,

  /* The shared launcher integration consumes these fields to keep the rocket
   * as a travelling projectile and to apply radial damage on impact. Direct
   * impact plus the explosive charge is deliberately lethal against the new
   * 10x-health baseline; splash alone is heavy but survivable at the edge. */
  projectileType: 'rocket',
  explosiveRadius: 7.5,
  explosiveDamage: 700,
  explosiveMinDamage: 90,
  armingDistance: 2.0,
  muzzleVelocity: 115,
  damage: 350,
  penetration: 0.15,
  dropoff: 0,
  maxRange: 500,
  dragK: 0.045,
  tracerEvery: 1,
  ejectsShell: false,

  spreadHip: 4.5,
  spreadAds: 0.22,
  spreadPerShot: 0.8,
  spreadMax: 5.0,
  spreadDecay: 2.0,

  recoil: {
    pitch: 0.025,
    yaw: 0.0045,
    kickBack: 0.04,
    kickUp: 0.018,
    roll: 0.06,
    punch: 0.78,
    freq: 5.2,
    damping: 0.55,
    patternLength: 1,
    patternSeed: 0x7a77c1,
    climbShape: [1.0],
    drift: 0.2,
  },

  /* An RPG-7 is loaded at the MUZZLE, not through a magwell: the round goes in
   * at the front of the launch tube (`magSeat`, z = -0.47). `clips.js` builds a
   * dedicated reload for this style — launcher down off the shoulder, tube
   * yawed inboard, the round carried to the muzzle — because the generic
   * box-magazine timeline puts the support hand ~0.3 m past what the arm can
   * reach and splits the wrist. */
  reloadStyle: 'muzzle',

  adsTime: 0.42,
  adsFov: 0.76,
  viewFov: 0.88,
  reloadTac: 4.8,
  reloadEmpty: 5.4,
  inspectTime: 3.8,
  drawTime: 0.9,
  holsterTime: 0.62,

  /* Solved around the launch tube's bore: the crown/rocket nose remains in
   * frame up-left while the rear venturi and firing grip stay below-right. */
  hipPos: [0.125, -0.2, -0.39],
  hipRot: [-0.055, 0.085, -0.14],
  adsCant: [0, 0, 0.004],
  eyeRelief: 0.18,
  sprintPos: [0.1, -0.31, -0.34],
  sprintRot: [-0.48, 0.62, 0.23],
  lowReadyPos: [0.12, -0.32, -0.37],
  lowReadyRot: [-0.5, 0.15, -0.1],
  swayScale: 1.3,
  bobScale: 0.72,
  magLen: 0.52,
};

export const loadModel = () => import('../models/rpg.js').then((m) => m.buildRpg);
